import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/DropdownMenu/DropdownMenu";

export const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // i18n persists to localStorage via LanguageDetector
  };

  const uzbFlagUrl =
    "https://upload.wikimedia.org/wikipedia/commons/8/84/Flag_of_Uzbekistan.svg";

  const usaFlagUrl =
    "https://cdn.britannica.com/79/4479-050-6EF87027/flag-Stars-and-Stripes-May-1-1795.jpg";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="flex w-[80px] cursor-pointer items-center gap-2">
          <FlagIcon
            flagUrl={i18n.language === "uz" ? uzbFlagUrl : usaFlagUrl}
          />
          <span className="text-sm font-medium">
            {i18n.language === "uz" ? "Uz" : "Eng"}
          </span>
          <ChevronDown className="ml-auto h-4 min-w-4" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="ml-2 w-[100px]">
        <DropdownMenuItem
          className="cursor-pointer bg-transparent transition-colors duration-200 hover:bg-gray-100"
          onClick={() => changeLanguage("uz")}
        >
          <FlagIcon flagUrl={uzbFlagUrl} />
          <span className="ml-2">Uzbek</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          className="cursor-pointer bg-transparent transition-colors duration-200 hover:bg-gray-100"
          onClick={() => changeLanguage("en")}
        >
          <FlagIcon flagUrl={usaFlagUrl} />
          <span className="ml-2">English</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export function FlagIcon({ flagUrl }: { flagUrl: string }) {
  return (
    <img
      src={flagUrl}
      className="ml-2 h-5 w-6 rounded-sm bg-cover object-cover"
      alt="flag"
    />
  );
}
